if (!customElements.get('mystery-box-customizer')) {
  class MysteryBoxCustomizer extends HTMLElement {
    connectedCallback() {
      this.modeRadios = this.querySelectorAll('[data-mbc-mode]');
      this.fields = this.querySelectorAll('[data-mbc-field]');
      this.message = this.querySelector('[data-mbc-message]');
      this.messageCounter = this.querySelector('[data-mbc-count]');
      this.messageOriginalName = this.message ? this.message.getAttribute('name') : null;

      if (this.message) this.message.removeAttribute('name');

      this.modeRadios.forEach((r) => r.addEventListener('change', () => this.update()));

      this.fields.forEach((field) => {
        field.querySelectorAll('[data-mbc-chip]').forEach((input) => {
          input.addEventListener('change', () => this.update());
        });
        const free = field.querySelector('[data-mbc-free]');
        if (free) free.addEventListener('input', () => this.update());
      });

      if (this.message) this.message.addEventListener('input', () => this.update());

      this.update();
    }

    isCustomMode() {
      const checked = [...this.modeRadios].find((r) => r.checked);
      return checked ? checked.value === 'custom' : false;
    }

    update() {
      const isCustom = this.isCustomMode();
      this.dataset.mode = isCustom ? 'custom' : 'surprise';

      this.fields.forEach((field) => this.syncField(field, isCustom));
      if (this.message) this.syncMessage(isCustom);
    }

    syncField(field, isCustom) {
      const property = field.querySelector('[data-mbc-property]');
      if (!property) return;

      if (!isCustom) {
        property.setAttribute('disabled', '');
        return;
      }

      const inputs = field.querySelectorAll('[data-mbc-chip]');
      const free = field.querySelector('[data-mbc-free]');
      const selected = [];

      inputs.forEach((input) => {
        if (input.checked) selected.push(input.value);
      });

      if (free && free.value.trim()) {
        free.value
          .split(',')
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
          .forEach((v) => {
            if (!selected.includes(v)) selected.push(v);
          });
      }

      const value = selected.join(', ');
      property.value = value;
      if (value) {
        property.removeAttribute('disabled');
      } else {
        property.setAttribute('disabled', '');
      }
    }

    syncMessage(isCustom) {
      if (this.messageCounter) this.messageCounter.textContent = this.message.value.length;

      if (isCustom && this.message.value.trim()) {
        this.message.setAttribute('name', this.messageOriginalName);
      } else {
        this.message.removeAttribute('name');
      }
    }
  }

  customElements.define('mystery-box-customizer', MysteryBoxCustomizer);
}
